export { default as SectionViewedLogger } from './SectionViewedLogger';
export type { OwnProps as SectionViewedLoggerProps } from './SectionViewedLogger';
